module.exports = __webpack_public_path__ + "img/IMG_8155_L_Foamcore_MockedUp.d5ccf5ad.jpg";